import React from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

function AdministrarConvenios() {

    return (
        
        <div className="hold-transition">
            <Header />
            <Aside activelink="settings" />
            
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-8">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item" key={'k1'}><Link to="/home">Home</Link></li>
                                    <li className="breadcrumb-item" key={'k2'}><Link to="/settings">Configuración</Link></li>
                                    <li className="breadcrumb-item" key={'k3'}>Administrar Empresas y Convenios</li>
                                </ol>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-sm-8">
                                <h1 className="m-0">Administrar Empresas y Convenios</h1>
                            </div>
                        </div>
                    </div>
                </div>
                <section className="content" >
                    <div className="container-fluid">

                        
                        <div className="row">
                            <div className="col-md-12 btn-settings-container">
                                
                                <Link to="/empresas" className="btn-settings">
                                Empresas
                                </Link>

                                <Link to={"/convenios"} className="btn-settings">
                                Convenios
                                </Link>

                                <Link to={"/lista-precios-convenio"} className="btn-settings">
                                Listado de Precios
                                </Link>

                            </div>          
                        </div>

                    </div>
                </section>
            </div>
            <Footer showToast={false} delay={0} />
        </div>
        
    );
}
export default AdministrarConvenios;